/**
 * @generated SignedSource<<e4c9681adb870b08c88e0f053c2433f2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GeneralHealthInformationFragment$data = {
  readonly allergies: string | null;
  readonly conditions: string | null;
  readonly medication: string | null;
  readonly " $fragmentType": "GeneralHealthInformationFragment";
};
export type GeneralHealthInformationFragment$key = {
  readonly " $data"?: GeneralHealthInformationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GeneralHealthInformationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeneralHealthInformationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conditions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allergies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medication",
      "storageKey": null
    }
  ],
  "type": "GeneralHealthInformation",
  "abstractKey": null
};

(node as any).hash = "ac176f097814d350986dded155a23861";

export default node;
